export const REVIEW_STATUS = {
  form_pending: { label: "Formulario pendiente", fg: "#a3a3a3" },
  form_completed: { label: "Formulario completado", fg: "#60a5fa" },
  info_review: { label: "Información por revisar", fg: "#f87171" },
  draft_generating: { label: "Borrador en generación", fg: "#c084fc" },
  draft_ready: { label: "Borrador listo para revisión", fg: "#facc15" },
  info_needed: { label: "Pendiente de información adicional", fg: "#fb923c" },
  coach_review: { label: "En revisión del entrenador", fg: "#38bdf8" },
  approved: { label: "Aprobado", fg: "#4ade80" },
  published: { label: "Publicado para el cliente", fg: "#22c55e" },
  none: { label: "Sin planificación en revisión", fg: "#737373" },
};

export const NEEDS_ATTENTION = ["form_completed", "info_review", "draft_ready", "coach_review"];

export const SECTIONS = [
  ["summary", "Resumen de la planificación"],
  ["objectives", "Objetivos"],
  ["considerations", "Consideraciones y precauciones"],
  ["recovery", "Recuperación"],
  ["nutrition", "Nutrición"],
];

export const VERSION_KIND = { manual: "Guardada a mano", published: "Publicada", auto_before_restore: "Copia automática", auto_before_ai: "Copia antes de la IA", ai_generated: "Generada por IA" };
